export const PORTAL_NAME = 'cust-web'

// Custom URL scheme used by the native apps
export const APP_DEEP_LINK_SCHEME = "eprakashak://";

// Android – Play Store
export const ANDROID_APP_URL =
  process.env.REACT_APP_ANDROID_APP_URL ||
  "https://play.google.com/store/apps/details?id=com.eprakashak";

// iOS – App Store
export const IOS_APP_URL =
  process.env.REACT_APP_IOS_APP_URL ||
  "https://apps.apple.com/in/app/eprakashak/id6738301193";

// Windows – Microsoft Store
export const WINDOWS_APP_URL =
  process.env.REACT_APP_WINDOWS_APP_URL ||
  "https://apps.microsoft.com/detail/9NQLDLTKSZGQ?hl=en-us&gl=US&ocid=pdpshare";

// macOS – App Store (same URL as iOS in this case)
export const MAC_APP_URL =
  process.env.REACT_APP_MAC_APP_URL ||
  "https://apps.apple.com/in/app/eprakashak/id6738301193";

// Linux – optional URL (e.g., .deb/.AppImage download page); empty by default
export const LINUX_APP_URL = process.env.REACT_APP_LINUX_APP_URL || "";
